import { BaseService } from "./base.service";
import { detect } from "detect-browser";

export class PurlTrackingService extends BaseService {
  static track(label = "") {
    try {
      this.request().post(`${process.env.VUE_APP_API_TRACKING_PATH}`, {
        action: "tracking",
        label: label === "browser" ? `browser/${detect().name}` : label,
      });
    } catch (e) {
      throw new Error("Server error: Tracking is not working.");
    }
  }
}
